var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"product-main",attrs:{"id":"product-navbar"}},[_c('div',{staticClass:"g-body"},[_c('transition',{staticClass:"el-main",attrs:{"name":"move","mode":"out-in"}},[_c('router-view',{key:"Bear"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }